import { Card, CardContent, Grid } from "@mui/material";
import TypeTablesEditor from "../../../components/backoffice-type-tables/TypeTablesEditor";

const TypeTables = () => {
  return (
    <>
      <Grid
        container
        pt="0px"
        spacing={2}
        sx={{
          heigth: "auto",
          width: "auto",
          marginBottom: 3,
          marginTop: 0,
          paddingBottom: 22,
        }}
      >
        <Grid item xs={12}>
          <Card
            elevation={3}
            align="center"
            sx={{ heigth: "auto", width: "auto" }}
          >
            <CardContent>
              <TypeTablesEditor />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default TypeTables;
